import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MemoInput = ({ value, onChange, vendor = "", className = "", placeholder = "Memo / description", testId = "memo-input", ...rest }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const focused = useRef(false);

  useEffect(() => {
    if (!focused.current) return;
    const t = setTimeout(() => {
      axios.get(`${API}/transactions/memo-suggestions`, { params: { q: value || "", vendor } })
        .then(r => { setItems(r.data); setActive(-1); setOpen(focused.current && r.data.length > 0); }).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [value, vendor]);

  const pick = (text) => { onChange(text); setOpen(false); };
  const onKeyDown = (e) => {
    if (!open || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive(a => (a + 1) % items.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive(a => (a - 1 + items.length) % items.length); }
    else if ((e.key === "Enter" || e.key === "Tab") && active >= 0) { e.preventDefault(); pick(items[active].text); }
    else if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative">
      <Input {...rest} value={value} placeholder={placeholder} className={className} data-testid={testId} autoComplete="off"
        onChange={e => onChange(e.target.value)} onKeyDown={onKeyDown}
        onFocus={() => { focused.current = true; axios.get(`${API}/transactions/memo-suggestions`, { params: { q: value || "", vendor } }).then(r => { setItems(r.data); setOpen(r.data.length > 0); }).catch(() => {}); }}
        onBlur={() => { focused.current = false; setTimeout(() => setOpen(false), 150); }} />
      {open && (
        <div className="absolute z-50 left-0 right-0 mt-1 bg-white border border-stone-200 rounded-lg shadow-lg overflow-hidden max-h-60 overflow-y-auto" data-testid={`${testId}-suggestions`}>
          {items.map((it, i) => (
            <button key={it.text} type="button" onMouseDown={e => { e.preventDefault(); pick(it.text); }} data-testid={`${testId}-suggestion-${i}`}
              className={`w-full text-left px-3 py-1.5 text-xs flex items-center gap-2 transition-colors ${i === active ? "bg-stone-100" : "hover:bg-stone-50"}`}>
              <span className="flex-1 truncate text-stone-800">{it.text}</span>
              {it.vendor_match && <span className="text-[9px] uppercase tracking-wide text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded">this provider</span>}
              <span className="text-[10px] text-stone-400">{it.count}×</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
